import { LocaleMap } from '@unifocus/js-utils';

/**
 * WARNING: This file is auto-generated from the bundle-localization tool. Do not edit this file directly.
 *
 * This file contains resource strings used by the @unifocus/js-utils formatMessage function.
 */
const messages: LocaleMap = {
   "en": {
      "res_validationErrorTitle": "Validation Error",
      "res_userIDSectionHeader": "Enter your User ID",
      "res_invalidEmpID": "The ID {0} you entered does not match any records currently on file. Please try again and if you continue to receive this message, please contact your manager for assistance with resetting your access",
      "res_pinSectionHeader": "Enter your PIN",
      "res_invalidPIN": "The PIN you enter does not match the record on file for this employee profile. Please try again or contact your manager for assistance with resetting your PIN.",
      "res_in": "In",
      "res_break": "Break",
      "res_back": "Back",
      "res_out": "Out",
      "res_enter": "Enter",
      "res_employeeNameTitle": "Welcome {0}",
      "res_successModalTitle": "Success",
      "res_successfulPunch": "Punch was successful",
      "res_stop": "Stop",
      "res_continue": "Continue",
      "res_activationPending": "This device is not yet activated to run the time clock application. In order to activate this device you will need to log in and activate the device. Press the Continue button to start this process",
      "res_unauthorizedTimeClockActivationUser": "You are not authorized to activate time clocks. Contact your system administrator for assistance.",
      "res_ok": "OK",
      "res_noTimeClockAvailable": "There are no time clock configurations available to activate. Contact your system administrator for assistance.",
      "res_validationError": "Validation Error",
      "res_invalidCredentials": "The username or password could not be verified. Check your credentials and try again.",
      "res_signIn": "Sign In",
      "res_punchError": "There was an issue processing the punch",
      "res_signOut": "Sign Out",
      "res_myShifts": "My Shifts",
      "res_suggestedPunchConfirmation": "Punch Confirmation",
      "res_suggestedPunchConfirmationBodyString": "This is not the suggested punch type based on your current punch status, do you wish to proceed anyway?",
      "res_punchAttestationError": "There was an issue processing the punch attestations",
      "res_punchCorrectionError": "There was an issue processing the punch corrections",
      "res_error": "Error",
      "res_employeeShiftError": "There was an issue fetching the details of the shift",
      "res_invalidUsername": "The username could not be verified. Check your credentials and try again",
      "res_switchJob": "Switch Job",
      "res_fixPunch": "Fix Punch",
      "res_employeeCorrection": "Employee Corrections",
      "res_earningType": "Earning Type:",
      "res_amount": "Amount:",
      "res_earningAdded": "Earning Added",
      "res_earningDeleted": "Earning Deleted",
      "res_earningChanged": "Earning Changed",
      "res_approve": "Approve",
      "res_reject": "Reject",
      "res_enrollEmployee": "Enroll Employee",
      "res_enterEmployeeId": "Enter Employee ID",
      "res_checkFpuConnection": "Checking fingerprint device connection...",
      "res_employeeNotFoundOffline": "The employee record could not be found in offline mode"
   }
};

export default messages;
